import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import { Provider } from 'react-redux';
import {
  BrowserRouter, Redirect, Route, Switch,
} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { CookiesProvider } from 'react-cookie';
import * as Sentry from '@sentry/react';
import App from './App';
import { persistor, store } from './store';
import * as serviceWorker from './serviceWorker';
import LoadingProvider from './context/Loading';
import ModalErrorProvider from './context/ModalError';

const APP_SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const APP_SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;

Sentry.init( {
  dsn: APP_SENTRY_DSN,
  environment: APP_SENTRY_ENV,
  integrations: [
    new Sentry.BrowserTracing( {
      tracePropagationTargets: ['localhost', /^https:\/\/qa\.payment\.portal\.pt\.slorapp\.com/],
    } ),
    // new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
} );

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoadingProvider>
          <ModalErrorProvider>
            <BrowserRouter>
              <CookiesProvider>
                <Switch>
                  <Route path="/" component={App} />
                  <Redirect from="*" to="/" />
                </Switch>
              </CookiesProvider>
            </BrowserRouter>
          </ModalErrorProvider>
        </LoadingProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById( 'root' ),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
